/**
 * The platform's game catalog, for filter dropdowns. Static because the three
 * games are platform-wide; admins shouldn't have to recall the exact gameId
 * string (greedyking / sicbo / dragontiger) and type it free-hand.
 */
export const GAME_IDS = [
  'greedyking',
  'sicbo',
  'dragontiger',
  'singaporelottery',
  'baccarat',
  'shortdicerush',
  'longdicerush',
  'crash' /* apx-cli:games-id:crash */,
] as const;

const PRETTY: Record<string, string> = {
  crash: 'Crash' /* apx-cli:games:crash */,
  greedyking: 'GreedyKING',
  sicbo: 'Sic Bo',
  dragontiger: 'Dragon Tiger',
  singaporelottery: 'Singapore Lottery',
  baccarat: 'Baccarat',
  shortdicerush: 'Short Dice Rush',
  longdicerush: 'Long Dice Rush',
};

/** Human label for a gameId, falling back to the raw id for unknown games. */
export function prettyGame(gameId: string): string {
  return PRETTY[gameId] ?? gameId;
}

/**
 * `<option>` list for a game `<select>`. Pass the currently-selected gameId.
 * If `includeAny` is set, prepends an "All games" ("") option.
 */
export function gameOptions(selected: string, includeAny = false): string {
  const any = includeAny ? `<option value=""${selected ? '' : ' selected'}>All games</option>` : '';
  const opts = GAME_IDS.map(
    (id) => `<option value="${id}"${id === selected ? ' selected' : ''}>${prettyGame(id)}</option>`,
  ).join('');
  return any + opts;
}
